import { currentLanguage } from "../../algorithms/storage";
import axios from "../axiosConfig";
export const getAllSubTask = (taskId, token) => {
  return axios.post(
    `SubPresidentalTask/SearchSubTasks/${taskId}`,
    {},
    {
      headers: {
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    },
  );
};
export const addSubAssignment = (data, token) => {
  return axios.post(`SubPresidentalTask/AddSubTask`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
export const updateSubAssignment = (data, token) => {
  return axios.post(`SubPresidentalTask/UpdateTask`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getSubAssignment = (id, token) => {
  return axios.get(`SubPresidentalTask/Details/${id}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

///responces

export const addSubTaskResponse = (owner, taskprocedureId, data, token) => {
  return axios.post(
    `/SubPresidentalTaskComment/AddTaskComment/?taskprocedureId=${taskprocedureId}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    },
  );
};
export const updateSubTaskResponse = (data, token) => {
  return axios.post(`SubPresidentalTaskComment/EditComment`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getAllSubTaskResponses = (id, token) => {
  return axios.get(`SubPresidentalTaskComment/GetComments/${id}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
